import React, { Component } from 'react';
// import { Link } from 'react-router-dom';

import './error.less';

class Error404 extends Component {

    state = {
        errorList: [
            'http://s1.im-dangdang.com/online/20181009/dbb44aed2e738bd40568d70caa8b87d6277ff946.jpg',
            'http://s1.im-dangdang.com/online/20181009/sl0219gjeq1.jpg',
            'http://s1.im-dangdang.com/online/20181009/404sj60.jpg',
            'http://s1.im-dangdang.com/online/20181009/faedab64034f78f0e4c877d472310a55b2191cd1.jpg',
            'http://s1.im-dangdang.com/online/20181009/9f510fb30f2442a76a08e28eda43ad4bd1130292.jpg',
            'http://s1.im-dangdang.com/online/20181009/015c4357764df30000012e7e576eae.jpg',
            'http://s1.im-dangdang.com/online/20181009/26422107_220358106081_2.jpg',
            'http://s1.im-dangdang.com/online/20181009/017be1572c480032f875a399f14c43.jpg@1280w_1l_2o_100sh.jpg',
            'http://s1.im-dangdang.com/online/20181009/2934349b033b5bb5f6f819d43dd3d539b600bce8.jpg',
            'http://s1.im-dangdang.com/online/20181009/bd315c6034a85edf4a44000542540923dc5475c8.jpg',
            'http://s1.im-dangdang.com/online/20181009/f31fbe096b63f62472e32f388c44ebf81a4ca34a.jpg',
            'http://s1.im-dangdang.com/online/20181009/2e2eb9389b504fc290f2b02deedde71190ef6d6c.jpg',
            'http://s1.im-dangdang.com/online/20181009/00e93901213fb80eb49bf0ec3dd12f2eb9389447.jpg'
        ]
    }

    constructor (props) {
        super(props)
        this.init()
    }

    delay (ms) {
        ms = ms || 1000;
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve()
            }, ms)
        })
    }

    async init () {
        await this.delay()
    }

    render() {
        const { errorList } = this.state;
        return (
            <div className="error-404">
                <div className="error-404-empty">
                    <div className="grid-wrap">
                        {
                            errorList.map((item, index) => {
                                return <div key={index} className="grid-item" style={{backgroundImage: 'url('+ item +')'}}></div>
                            })
                        }
                    </div>
                    <p className="error">很抱歉，您所访问的页面找不到了</p> 
                </div>
            </div>
        )
    }
}

export default Error404
